// import React from 'react';
// import '../Stylesp/ProtectCloud.css';
// import { InView } from 'react-intersection-observer';

// const ProtectCloud = () => {
//   return (
//     <div>
//       <section
//         className="protectcloud-banner"
//         role="banner"
//         aria-labelledby="protectcloud-banner-title"
//       >
//         <div className="protectcloud-banner-container">
//           <InView triggerOnce={true} threshold={0.1}>
//             {({ inView, ref }) => (
//               <header
//                 ref={ref}
//                 className={`protectcloud-banner-content ${inView ? "animate" : ""
//                   }`}
//               >
//                 <h1 id="protectcloud-banner-title">Endpoint Management & Security</h1>
//                 {/* <p>
//                   Secure, manage, and optimize all your endpoints with an
//                   all-in-one cloud-native solution.
//                 </p> */}
//               </header>
//             )}
//           </InView>
//         </div>
//       </section>
//       <div className="protect-cloud-container">
//         <div className="protect-cloud-header">
//           <div className="protect-cloud-content">
//             <div className="protect-cloud-text">
//               <h1>Endpoint Management</h1>
              
//               <p className="first-paragraph">
//                 Synectiks offers an innovative <b>ALL-IN-ONE endpoint management solution</b>, an AI-powered, web-based platform that includes next-generation anti-malware, remote monitoring and management (RMM), vulnerability assessment, patch management, backup, and disaster recovery, all delivered through a single agent for servers and endpoint devices. This solution provides a complete cyber protection stack designed to simplify IT operations while maximizing security and resilience for your business. It covers everything from advanced threat detection (XDR, EDR, MDR) to backup, disaster recovery, and data protection, reducing complexity and operational overhead.
//               </p>
//               <p className="first-paragraph">
//                 Synectiks protects endpoints, servers, virtual machines, and mobile devices with proactive monitoring through RMM and rapid recovery through disaster recovery capabilities. The solution also includes <b>email security and email archiving</b> to protect against phishing, malware, and compliance risks, while <b>data loss prevention (DLP)</b> safeguards sensitive data without impacting productivity.
//               </p>
//             </div>
//             <div className="protect-cloud-form">
//               <div className="form-container">
//                 <h2 className="form-title">Request for a Quick Demo</h2>{" "}
//                 <form>
//                   <div className="form-group">
//                     <label htmlFor="name">Your Name *</label>
//                     <input type="text" id="name" required />
//                   </div>
//                   <div className="form-group">
//                     <label htmlFor="email">Email *</label>
//                     <input type="email" id="email" required />
//                   </div>
//                   <div className="button-wrapper">
//                     <button type="submit" className="submit-button">
//                       Learn More
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProtectCloud;
















import React from 'react';
import { InView } from 'react-intersection-observer';
import '../Stylesp/ProtectCloud.css';

const ProtectCloud = () => {
  return (
    <div className="protectcloud-wrapper">
      {/* Banner Section */}
      <section
        className="protectcloud-banner"
        role="banner"
        aria-labelledby="protectcloud-banner-title"
      >
        <div className="protectcloud-banner-container">
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <header
                ref={ref}
                className={`protectcloud-banner-content ${inView ? "animate" : ""}`}
              >
                <h1 id="protectcloud-banner-title">Endpoint Management & Security</h1>
              </header>
            )}
          </InView>
        </div>
      </section>

      {/* Content Section - Static Form Removed */}
      <div className="protect-cloud-container">
        <div className="protect-cloud-header">
          {/* <div className="protect-cloud-content"> */}
            <div className="protect-cloud-text full-width">
              <h1>Endpoint Management</h1>
              <p className="first-paragraph">
                Synectiks offers an innovative <b>ALL-IN-ONE</b> endpoint management solution, an AI-powered, web-based platform that includes next-generation anti-malware, remote monitoring and management (RMM), vulnerability assessment, patch management, backup, and disaster recovery, all delivered through a single agent for servers and endpoint devices. Synectiks protects endpoints, servers, virtual machines, and mobile devices with proactive monitoring through RMM and rapid recovery through disaster recovery capabilities. The solution also includes email security and email archiving to protect against phishing, malware, and compliance risks, while data loss prevention (DLP) safeguards sensitive data without impacting productivity.

              </p>
              {/* <p className="first-paragraph">
              </p> */}
            </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default ProtectCloud;